<script setup lang="ts">
const emits = defineEmits(["animationend"])
const handleAnimationEnd = () => {
  emits("animationend", 0)
}
</script>

<template>
  <div class="animation-like" @animationend="handleAnimationEnd"></div>
</template>

<style scoped lang="scss">
.animation-like {
  pointer-events: none; // 使其不被点击，直接穿透到父级去
  width: 60px;
  height: 50px;

  background: url("@/assets/img/animate-like.png") no-repeat;
  background-position-x: 0;
  background-position-y: 0;
  background-size: cover;
  animation: moveBackground 1.32s steps(33);
  // 25fps = 1秒25帧 = 每帧用时40ms
  // 总帧数 33 * 40ms = 1320ms = 1.32s
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  position: relative;
  bottom: 10px;
}

@keyframes moveBackground {
  0% {
    background-position-y: 0;
  }
  100% {
    background-position-y: -1650px; // 实际有效高度
  }
}
</style>
